export { PercentBar as default, PercentBarDeprecated } from './PercentBar';
